// @flow
export { default } from './containers/Register'
